export default __webpack_public_path__ + "static/media/instagram.889b5209.svg";